import { useEffect } from "react";

/**
 * Setzt document.title. Nutze mit Mandanten-Namen wenn vorhanden:
 *   usePageTitle("Buchung", tenantName)
 *   usePageTitle("Login")   → "Login — Tonneva"
 */
export default function usePageTitle(page, tenantName) {
  useEffect(() => {
    const base = tenantName || "Tonneva";
    document.title = page ? `${page} — ${base}` : base;
  }, [page, tenantName]);
}
